import { SendNotificationPayload } from "@/data/payload/dashboard/send-notification-payload";
import { URLList } from "@/data/url_list";
import { DashboardHomeScope } from "@/domain/entity/dashboard/dashboard-entity";
import { createLogger, withApiLogging } from "@/utils/logger/logger";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class DashboardSource {
  private readonly logger = createLogger("DashboardSource");

  constructor(private readonly client: FetchApiClientMethod) {}

  async fetchDashboard(scope: DashboardHomeScope = "doctor"): Promise<SATResult<unknown, SATError>> {
    const url =
      scope === "admin" ? URLList.DASHBOARD.ADMIN_HOME : URLList.DASHBOARD.DOCTOR_HOME;
    try {
      const data = await withApiLogging(this.logger, { method: "GET", url }, async () => {
        const response = await this.client.get(url);
        return response.data;
      });
      return SATResult.success(data);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }

  async sendNotification(payload: SendNotificationPayload): Promise<SATResult<void, SATError>> {
    const url = URLList.DASHBOARD.SEND_NOTIFICATION;
    try {
      await withApiLogging(this.logger, { method: "POST", url, payload }, async () => {
        const response = await this.client.post(url, payload);
        return response.data;
      });
      return SATResult.success(void 0);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }
}
